import { createFileRoute } from '@tanstack/react-router'

import { OfficeBoardScreen } from './-components/office-board-screen.tsx'

/** The office TV board: company totals on a loop of full-screen views. */
export const Route = createFileRoute('/company/tv-board')({
  component: OfficeBoardScreen
})
